import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import styled from'styled-components';

import { COLORS } from 'apps/web_forms/utils/constants'

import { resetNotification } from 'apps/web_forms/slices/appSlice';
import { selectNotification } from 'apps/web_forms/hooks/useGlobalSelector';

const StyledNotification = styled.div`
  position: sticky;
  z-index: 3;
  text-align: center
  height: 2.778em;
  top: 0px;
  left: 0px;
  width: calc(100% + 10px);
  width: calc(100% - 2em);
  margin: -2em 1em 1em;
  background-color: white;
  border-bottom: 2px solid rgb(221, 221, 221);
  border-radius: 0;
  border: none;
`;

const StyledNotificationColumns = styled.div`
  position: sticky;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  z-index: 3;
  height: 2.778em;
  top: 0;
  left: 0;
  right: 0;
  width: calc(100% - 2em);
  margin: -2em 1em 1em;
  padding: 0 2em;
  background-color: white;
  border-bottom: 2px solid rgb(221, 221, 221);
  border-radius: 0;
  border: none;

  .notification-text {
    text-align: left;
  }

  .notification-action {
    text-align: right;

    button {
      border: 2px solid ${COLORS.green};
      background-color: ${COLORS.green};
      color: ${COLORS.inputBackgroundColor};
      box-sizing: border-box;
      border-radius: 2.5em;
      min-width: 120px;
      padding: 0.5em 1.4em;
      font-weight: bold;
      font-family: Helvetica, Roboto;
      font-size: 13px;
    }
  }
`;

export const NotificationBox = () => {
  const notification = useSelector(selectNotification);
  const dispatch = useDispatch();

  if (notification.type && notification.text) {
    setTimeout(() => {
      dispatch(resetNotification());
    }, 3000);

    return (
      <Notification
        notificationText={notification.text}
        type={notification.type}
      />
    );
  }

  return null;
};

const Notification = ({ notificationText, type, style = '', children = '' }) => {
  const normalNotification = (
    <StyledNotification className={`notification-box ${type}`}>
      <p>{notificationText}</p>
    </StyledNotification>
  );

  const notificationWithColumns = (
    <StyledNotificationColumns className={`notification-box ${type} notification-2-columns`}>
      <div className='notification-text'>
        <p>{notificationText}</p>
      </div>
      <div className='notification-action'>
        {children}
      </div>
    </StyledNotificationColumns>
  );

  return style === '2-columns'? notificationWithColumns : normalNotification;
};

Notification.propTypes = {
  notificationText: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['success', 'warning', 'error']),
};

Notification.defaultProps = {
  type: 'success',
};

export default Notification;
